import { createPortal } from "react-dom";

import { Column, Text } from "@/components";

import { performanceTierTextClass } from "@/lib/constants";
import { dashboardKpis } from "@/lib/dashboardKpis";
import { formatting } from "@/lib/formatting";
import { cn } from "@/lib/utils";
import { DashboardComparisonMetric, PerformanceTier } from "@/types";

const TOOLTIP_GAP_PX = 8;

// Follows the cursor across the bars, so it's portalled out of the card rather
// than clipped by it.
export const StafferComparisonTooltip = ({
  goal,
  isRanked,
  metric,
  name,
  tier,
  value,
  x,
  y,
}: {
  goal: number;
  isRanked: boolean;
  metric: DashboardComparisonMetric;
  name: string;
  tier: PerformanceTier;
  value: number;
  x: number;
  y: number;
}) =>
  createPortal(
    <Column
      className="pointer-events-none fixed z-50 overflow-hidden rounded-md border border-slate-200 bg-white px-3 py-2 shadow-md"
      style={{
        left: x,
        top: y - TOOLTIP_GAP_PX,
        transform: "translate(-50%, -100%)",
      }}
    >
      <Text className="text-xs font-semibold text-slate-900">{name}</Text>
      <Text
        className={cn(
          "text-lg font-semibold tabular-nums leading-tight",
          metric === DashboardComparisonMetric.REVENUE
            ? "text-slate-900"
            : performanceTierTextClass[tier],
        )}
      >
        {isRanked ? dashboardKpis.formatValue(metric, value) : "—"}
      </Text>
      {metric === DashboardComparisonMetric.REVENUE ? (
        <Text className="text-xs font-normal text-slate-500">
          {formatting.currency(Math.max(goal - value, 0))} left to goal
        </Text>
      ) : null}
    </Column>,
    document.body,
  );
